module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-gun-metal-mill-finish-721-scale.0d4232e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-gun-metal-mill-finish-721-scale.jpg
// module id = 1129
// module chunks = 37